import type { PassTemplateMeta } from '../../../../store/types/pass';
import type {
  ImagesState,
  PassTemplateApiResponse,
} from '../../../../store/types/template';

export type TemplateImages =
  PassTemplateApiResponse['data']['attributes']['images'];

export const mapPassTemplateImages = (
  template: PassTemplateMeta,
  templateImages?: TemplateImages
): ImagesState => ({
  shared: {
    logo: templateImages?.logo || template.logo_image || '',
    icon: templateImages?.icon || template.icon_image || '',
    banner:
      (template.template_type === 'stampCard'
        ? template.stamp_zero_image
        : '') ||
      templateImages?.banner ||
      template.banner_image ||
      '',
  },
  apple: {
    logo: templateImages?.apple?.logo || template.apple_logo_image || '',
    icon: templateImages?.apple?.icon || template.apple_icon_image || '',
    banner: templateImages?.apple?.banner || template.apple_banner_image || '',
    thumbnail:
      templateImages?.apple?.thumbnail ||
      template.apple_thumbnail_image ||
      template.thumbnail_image ||
      '',
  },
  google: {
    logo: templateImages?.google?.logo || template.google_logo_image || '',
    wideLogo: templateImages?.google?.wideLogo || template.google_wide_logo_image || '',
    banner:
      templateImages?.google?.banner || template.google_banner_image || '',
  },
});
